import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import { BundleQuestionModel, BundleQuestionModelCore } from '../../../../models/survey/survey.model';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';
import { SurveyService } from '../../surveys.service';
@Component({
  selector: 'app-bundle-tab',
  templateUrl: './bundle-tab.component.html',
  styleUrls: ['./bundle-tab.component.less']
})
export class BundleTabComponent implements OnInit {

  @Input() surveyId: number;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  showLoader = false;
  showBundlePopup = false;
  model: BundleQuestionModel[];
  bundleModel: BundleQuestionModel;
  showDeleteBundleConfirm = false;
  deleteBundleModel: BundleQuestionModel;
  

  constructor(private surveyService: SurveyService, private renderer: Renderer2 ) {
  }

  ngOnInit(): void {
    this.loadBundles();
  }


  save() {
    this.showLoader = true;
  }

  addQuestionBundle(): void {
    this.renderer.addClass(document.body, 'modal-open');
    this.bundleModel = new BundleQuestionModel();
    this.showBundlePopup = true;
  }

  loadBundles(): void {
    this.surveyService.getAllBundles(this.surveyId).subscribe(res => {
        this.model = res;
    }, err => {

    });
  }

  onEditBundle(id: number): void {
    this.renderer.addClass(document.body, 'modal-open');
    this.surveyService.getBundle(id).subscribe(res => {
        this.bundleModel = res;
        this.showBundlePopup = true;
    }, err => {

    });
  }

  onDeleteBundle(bundle: BundleQuestionModel): void {
    this.deleteBundleModel = bundle;
    this.showDeleteBundleConfirm = true;
  }

  deleteBundle() {
    this.surveyService.deleteBundle(this.deleteBundleModel.id).subscribe(res => {
        this.loadBundles();
    }, err => {
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  isAdminRole() {
    return this.isAdmin || this.isCustomerAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/bundle-tab/bundle-tab.component.ts